import React from 'react';
import { __ } from '@wordpress/i18n';
import { H2 } from '../../ui/style';
import { requestCompletions, getDemo, downloadImages, installAstra } from '../import-site/import-utils'
import { useStateValue } from '../../store/store';
import TextField from '@material-ui/core/TextField';
import {
	NextStepLink,
	PreviousStepLink,
	DefaultStep,
	ProgressBar,
	ImagePreview,
} from '../../components/index'

const BusinessInformation = () => {
	const [{ businessWork }, dispatch] = useStateValue();
	const storedState = useStateValue();

	return (
		<DefaultStep
			content={
				<>
					<H2>{__('What does your business do', 'astra-sites')}</H2>
				</>
			}

			controls={
				<div>
					<TextField
						label={__('Describe your business', 'astra-sites')}
						variant="outlined"
						placeholder={__('Beauty Salon', 'astra-sites')}
						fullWidth={true}
						value={businessWork}
						onChange={(event) => {
							dispatch({
								type: 'set',
								businessWork: event.target.value,
							})
						}}
						classes={{ root: 'business-name' }}
					/>
				</div>
			}

			actions={
				<>
					<PreviousStepLink before>{__('Back', 'astra-sites')}</PreviousStepLink>
					<ProgressBar />
					<NextStepLink ml1 after onClick={(event) => {
						requestCompletions(storedState)
						downloadImages(storedState);
						getDemo(starterTemplates.demoId, storedState);
						installAstra( storedState );
					}}>{__('Create a Website', 'astra-sites')}</NextStepLink>
				</>
			}
			preview={
				<ImagePreview fileName='step-4.png' />
			}
		/>
	)
}

export default BusinessInformation;
